import {VmInputAttributes} from 'config/attributes'
import {forwardRef, createElement, Fragment, useState} from 'react'
import classNames from 'classnames'
import moment from 'moment'

const funcNull = () => {}
export const hidering = '!ring-0 !ring-transparent !ring-offset-0'
var VmInput = {propTypes: VmInputAttributes}
VmInput = forwardRef(
  (
    {
      style,
      label = false,
      disabled = false,
      readonly = false,
      required = false,
      className = '',
      typeInput = 'text',
      onClick = funcNull,
      onChange = funcNull,
      onChangeCapture = funcNull,
      onRateChange = funcNull,
      onRateChangeCapture = funcNull,
      onVolumeChange = funcNull,
      onVolumeChangeCapture = funcNull,
      onDurationChange = funcNull,
      onDurationChangeCapture = funcNull,
      onError = funcNull,
      onErrorCapture = funcNull,
      onInvalid = funcNull,
      onInvalidCapture = funcNull,
      onEmptied = funcNull,
      onEmptiedCapture = funcNull,
      onEnded = funcNull,
      onEndedCapture = funcNull,
      group = false,
      max = null,
      min = null,
      ...props
    },
    ref
  ) => {
    const [dateValue, setDateValue] = useState(props.value || '')
    if (props?.classNameContainer) {
      delete props.classNameContainer
    }
    if (typeInput === 'checkbox') {
      const checkboxid =
        props?.id || `checkbox-${moment().format('MMDDHHYYYYmmss')}`
      return (
        <Fragment>
          {createElement(
            'input',
            Object.assign(props, {
              type: 'checkbox',
              ref: ref,
              style: {
                position: 'absolute',
                opacity: 0,
                cursor: 'pointer',
                height: 0,
                width: 0,
              },
              id: checkboxid,
              required: required,
              'aria-label': label,
            })
          )}
          {createElement('span', {
            onClick: e => {
              if (!!e.target.previousSibling && !disabled) {
                e.target.previousSibling.click()
              }
            },
            className: classNames(
              className,
              disabled ? 'opacity-100 checkmark' : 'checkmark'
            ),
          })}
        </Fragment>
      )
    }

    if (typeInput == 'toggle') {
      return (
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            onChange={onChange}
            type="checkbox"
            className="sr-only peer"
            checked={props.checked}
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      )
    }
    const newclassName = classNames(
      'rounded-xl',
      !!props?.hidering ? hidering : '',
      className,
      disabled ? 'opacity-100' : ''
    )
    if (!!props?.hidering) {
      delete props.hidering
    }

    const handleDateChange = e => {
      const newValue = e.target.value
      setDateValue(moment(newValue).format('YYYY-MM-DD'))
      onChange(e)
    }

    if (typeInput === 'date') {
      return createElement('input', {
        ...props,
        type: 'date',
        value: moment(dateValue).format('YYYY-MM-DD'),
        onChange: handleDateChange,
        ref: ref,
        className: classNames('rounded-xl', className),
        style: style,
        disabled: disabled,
        readOnly: readonly,
        max: max,
        min: min,
        required: required,
        'aria-label': label,
      })
    }

    const Input = createElement(
      typeInput === 'textarea' ? 'textarea' : 'input',
      Object.assign(
        props,
        {
          ref: ref,
          type: typeInput === 'textarea' ? undefined : typeInput,
          style: style,
          disabled: disabled,
          readOnly: readonly,
          className: newclassName,
          onClick: disabled || readonly ? funcNull : onClick,
          onChange: disabled || readonly ? funcNull : onChange,
          onChangeCapture: disabled || readonly ? funcNull : onChangeCapture,
          onRateChange: disabled || readonly ? funcNull : onRateChange,
          onRateChangeCapture:
            disabled || readonly ? funcNull : onRateChangeCapture,
          onVolumeChange: disabled || readonly ? funcNull : onVolumeChange,
          onVolumeChangeCapture:
            disabled || readonly ? funcNull : onVolumeChangeCapture,
          onDurationChange: disabled || readonly ? funcNull : onDurationChange,
          onDurationChangeCapture:
            disabled || readonly ? funcNull : onDurationChangeCapture,
          onError: disabled || readonly ? funcNull : onError,
          onErrorCapture: disabled || readonly ? funcNull : onErrorCapture,
          onInvalid: disabled || readonly ? funcNull : onInvalid,
          onInvalidCapture: disabled || readonly ? funcNull : onInvalidCapture,
          onEmptied: disabled || readonly ? funcNull : onEmptied,
          onEmptiedCapture: disabled || readonly ? funcNull : onEmptiedCapture,
          onEnded: disabled || readonly ? funcNull : onEnded,
          onEndedCapture: disabled || readonly ? funcNull : onEndedCapture,
          required: required,
          'aria-label': label,
        },
        min != undefined ? {min} : {},
        max != undefined ? {max} : {}
      )
    )

    // console.log('render VmInput', Input)
    return Input
  }
)

export default VmInput
